import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-http-backend";

import translationEN from "./locales/en.json";
import translationFR from "./locales/fr.json";
import translationIT from "./locales/it.json";
import translationES from "./locales/es.json";
import translationDE from "./locales/de.json";
import translationPT from "./locales/pt.json";
import translationRU from "./locales/ru.json";
import translationZH from "./locales/zh.json";
import translationJA from "./locales/ja.json";
import translationKO from "./locales/ko.json";
import translationTR from "./locales/tr.json";
import translationPL from "./locales/pl.json";
import translationSV from "./locales/sv.json";
import translationDA from "./locales/da.json";
import translationFI from "./locales/fi.json";
import translationID from "./locales/id.json";
import translationCS from "./locales/cs.json";
import translationHU from "./locales/hu.json";
import translationEL from "./locales/el.json";
import translationRO from "./locales/ro.json";
import translationSK from "./locales/sk.json";
import translationUK from "./locales/uk.json";
import translationEE from "./locales/ee.json";
import translationLT from "./locales/lt.json";
import translationLV from "./locales/lv.json";
import translationSL from "./locales/sl.json";
import translationET from "./locales/et.json";
import translationBG from "./locales/bg.json";
import translationAR from "./locales/ar.json";
import translationMK from "./locales/mk.json";
import translationNO from "./locales/no.json";
import translationSR from "./locales/sr.json";

const options = {
  order: [
    "path",
    "navigator",
    "querystring",
    "cookie",
    "localStorage",
    "sessionStorage",
    "htmlTag",
  ],
  caches: ["localStorage", "cookie"],
  lookupLocalStorage: true,
  lookupQuerystring: true,
  lookupCookie: true,
  lookupSessionStorage: true,
  lookupFromPathIndex: 0,
  lookupFromSubdomainIndex: false,
  cacheUserLanguage: true,
  excludeCacheFor: ["cimode"],
  checkWhitelist: true,
  convertDetectedLanguage: "Iso15897",
  convertDetectedLanguage: (lng) => lng.replace("-", "_"),
};

i18n
  .use(XHR)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: options,
    load: "languageOnly",
    fallbackLng: "en",
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for React
    },
    react: {
      useSuspense: true,
    },
    resources: {
      en: {
        translation: translationEN,
      },
      es: {
        translation: translationES,
      },
      fr: {
        translation: translationFR,
      },
      de: {
        translation: translationDE,
      },
      it: {
        translation: translationIT,
      },
      pt: {
        translation: translationPT,
      },
      ru: {
        translation: translationRU,
      },
      zh: {
        translation: translationZH,
      },
      ja: {
        translation: translationJA,
      },
      ko: {
        translation: translationKO,
      },
      tr: {
        translation: translationTR,
      },
      pl: {
        translation: translationPL,
      },
      sv: {
        translation: translationSV,
      },
      da: {
        translation: translationDA,
      },
      fi: {
        translation: translationFI,
      },
      id: {
        translation: translationID,
      },
      cs: {
        translation: translationCS,
      },
      hu: {
        translation: translationHU,
      },
      el: {
        translation: translationEL,
      },
      ro: {
        translation: translationRO,
      },
      sk: {
        translation: translationSK,
      },
      uk: {
        translation: translationUK,
      },
      ee: {
        translation: translationEE,
      },
      lt: {
        translation: translationLT,
      },
      lv: {
        translation: translationLV,
      },
      sl: {
        translation: translationSL,
      },
      et: {
        translation: translationET,
      },
      bg: {
        translation: translationBG,
      },
      ar: {
        translation: translationAR,
      },
      mk: {
        translation: translationMK,
      },
      no: {
        translation: translationNO,
      },
      sr: {
        translation: translationSR,
      },
    },
  });

export default i18n;
